import React from "react";
import { useTranslation } from "react-i18next";          // 🆕 i18n import

const ProgressBar = ({ step }) => {
  const { t } = useTranslation("register");          // 🆕 namespace

  const getStepClass = (i) => {
    if (i < step) return "completed";
    if (i === step) return "current";
    return "next";
  };

  return (
    <div className="progress-bar-register">
      <div className={`progress-step ${getStepClass(1)}`}>
        <div className="circle">
          {step > 1 ? (
            <img src="/tick-circle.svg" alt={t("alt.completed")} />    
          ) : (
            "1"
          )}
        </div>
        <div className="step-name">{t("steps.basic")}</div>            
      </div>

      <div className={`progress-step ${getStepClass(2)}`}>
        <div className="circle">
          {step > 2 ? (
            <img src="/tick-circle.svg" alt={t("alt.completed")} />    
          ) : (
            "2"
          )}
        </div>
        <div className="step-name">{t("steps.legal")}</div>            
      </div>
    </div>
  );
};

export default ProgressBar;
